module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarTextInput",
    staticClass: "sidebar-tags"
  }, [_c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.data.tags), function(tag, index) {
    return _c('b-badge', {
      key: tag.text,
      staticClass: "tag mb-2",
      attrs: {
        "variant": "primary"
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(tag.text) + " "), _c('span', {
      staticClass: "tag badge badge-pill badge-info"
    }, [_vm._v(_vm._s(tag.s_attribut))]), _vm._v(" "), _c('span', {
      staticClass: "tag badge badge-pill badge-primary",
      style: ({
        'background-color': tag.color
      })
    }, [_vm._v(_vm._s(tag.s_type))])]), _vm._v(" "), _c('span', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.handleTagRemove(index)
        }
      }
    }, [_vm._v("×")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-input', {
    ref: "inputField",
    staticClass: "tagInput",
    attrs: {
      "text": _vm.tagInputText
    },
    on: {
      "input": _vm.handleChange
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "suggestions"
    }
  }, [_c('div', {
    staticClass: "suggestions-wrapper",
    on: {
      "click": _vm.handleSuggestionClick
    }
  }, [_c('p', {
    staticClass: "suggestions-title"
  }, [_vm._v("Vorschläge")]), _vm._v(" "), _c('div', {
    staticClass: "spinner-container"
  }, [(_vm.loading) ? _c('erco-spinner', {
    attrs: {
      "is-fixed-color": true
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.suggestions) ? _c('b-list-group', {
    staticClass: "suggestions"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('div', [_c('b-list-group-item', {
      key: suggestion,
      attrs: {
        "action": true,
        "data-index": index
      }
    }, [_c('span', {
      staticClass: "mr-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(suggestion.S_Value) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "tag badge badge-pill badge-info"
    }, [_vm._v(_vm._s(suggestion.S_Attribut))]), _vm._v(" "), _c('span', {
      staticClass: "tag badge badge-pill badge-primary",
      style: ({
        'background-color': suggestion.color
      })
    }, [_vm._v(_vm._s(suggestion.S_Type))])])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.suggestions && _vm.suggestions.length === 1) ? _c('div', {
    staticClass: "info_"
  }, [_c('span', {
    staticClass: "_text"
  }, [_vm._v("Keine Vorschläge gefunden")])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78009dca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/Tags.vue
// module id = 638
// module chunks = 0